import React from 'react';
import classNames from 'classnames';
import img from '../../assets/images/people.png';
// import CheckBox from '../CheckBox';
import style from './OnlineClub.module.scss';

function OnlineClub() {
    return (
        <section>
            <div className={style.wrapper}>
                <div className={classNames(style['wrapper-text'], '--border')}>
                    <div>
                        <h2>
                            Приєднайтеся до нашого онлайн-клубу
                        </h2>

                        <p>
                            Та першими  дізнавайтесь про новинки, акції, гарячі пропозиціі.
                        </p>

                        <form action='/' className={'online'}>
                            <fieldset>
                                <input type='text' className={classNames(style['input-text'], '--border')} placeholder={'Ваш email'} />
                                <button className={classNames(style['btn-pink'], '--border')}>
                                    Готово!
                                </button>
                            </fieldset>
                            {/* <CheckBox online name={'Даю сгоду на обробку персональних даних'} id={'online'} />*/}
                        </form>
                    </div>
                </div>
                <img
                    loading={'lazy'}
                    src={img}
                    alt='text'
                />
            </div>
        </section>
    );
}

export default React.memo(OnlineClub);
